import appGlobalScript from '/codebuild/output/src3177651253/src/packages/header/scripts/global.ts';
export const globalScripts = appGlobalScript;
